import { useEffect, useState, useContext } from "react";
import { SocketContext } from "../context/SocketProvider";
import { DEFAULT_ROOM } from "../constants/gameStages";

/**
 * Custom hook to synchronize game data with the server.
 * It listens for game data updates and provides the current game data and all images.
 * @returns {Object} An object containing the current game data and all images.
 * */
export function useGameDataSync() {
  const { socket } = useContext(SocketContext);
  const [gameData, setGameData] = useState(null);
  const [allImages, setAllImages] = useState([]);

  useEffect(() => {
    socket.emit("get_game_data", { room: DEFAULT_ROOM });

    socket.on("game_data", (data) => {
      setGameData(data);
      setAllImages(data.allImages || []);
    });

    return () => {
      socket.off("game_data");
    };
  }, [socket]);

  return { gameData, allImages };
}
